"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'company.form.title.edit': 'Editar Empresa',
    'company.form.title.add': 'Añadir Empresa',
    'company.form.back': 'Volver',
    'company.form.name.label': 'Nombre de la Empresa',
    'company.form.name.placeholder': 'Introducir nombre de la empresa',
    'company.form.nip.label': 'NIF',
    'company.form.nip.placeholder': '123-456-78-90',
    'company.form.email.label': 'Correo electrónico',
    'company.form.email.placeholder': 'correo@email.com',
    'company.form.phone.label': 'Teléfono',
    'company.form.phone.placeholder': '123 456 789',
    'company.form.address.label': 'Dirección',
    'company.form.street.placeholder': 'Calle y número',
    'company.form.postal_code.placeholder': 'Código postal',
    'company.form.city.placeholder': 'Ciudad',
    'company.form.website.label': 'Sitio web',
    'company.form.website.placeholder': 'https://empresa.com',
    'company.form.description.label': 'Descripción',
    'company.form.description.placeholder': 'Descripción de la empresa',
    'company.form.active.label': 'Activa',
    'company.form.logo.label': 'Logo de la Empresa',
    'company.form.logo.placeholder': 'Seleccionar logo de la empresa',
    'company.form.submit.update': 'Actualizar',
    'company.form.submit.create': 'Guardar',
    'company.form.submit.createCompanyData': 'Guardar Datos de la Empresa',
    'company.form.acl.loadError': 'Error al cargar los metadatos de ACL:',
    'company.form.load.error': 'Error al cargar la empresa',
    'company.form.submit.updateError': 'Error al actualizar la empresa',
    'company.form.submit.createError': 'Error al crear la empresa',
    'company.form.submit.updateSuccess': 'Empresa actualizada exitosamente',
    'company.form.submit.createSuccess': 'Empresa creada exitosamente',
};
